<template>
  <fragment>
    <v-breadcrumbs :items="routesBack">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
    </v-breadcrumbs>
    <AppBody :subtitle="titleModal">
      <editComboForm v-if="getComboType === 'edit'" />
      <comboForm v-else />
    </AppBody>
  </fragment>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AppBody from "@/layouts/components/AppBody.vue";

export default {
  name: "comboSettings",
  data() {
    return {};
  },
  components: {
    comboForm: () => import("@/components/produtos/combos/comboForm.vue"),
    editComboForm: () =>
      import("@/components/produtos/combos/editComboForm.vue"),
    AppBody,
  },
  computed: {
    ...mapGetters(["getComboType"]),
    titleModal() {
      return this.getComboType === "new" ? "Novo Combo" : "Editar Combo";
    },
    routesBack() {
      return [
        {
          text: "Combos",
          disabled: false,
          href: "/combos",
        },
        {
          text: this.titleModal,
          disabled: true,
        },
      ];
    },
  },
  methods: {
    ...mapActions(["getProductsCombo", "setTypeCombo"]),
  },
  mounted() {
    if (!this.getComboType) {
      this.$router.push("/combos");
    }
  },
};
</script>
